import { render, staticRenderFns } from "./KPIs.vue?vue&type=template&id=bedb8d92&scoped=true"
import script from "./KPIs.vue?vue&type=script&lang=js"
export * from "./KPIs.vue?vue&type=script&lang=js"
import style0 from "./KPIs.vue?vue&type=style&index=0&id=bedb8d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedb8d92",
  null
  
)

export default component.exports